import { translate } from "../../Translations/translatorService";
import { persistAlimony } from "../../Persist/AlimonyPersister";
import { stageMetaDataDocument } from "../../Stages/StagesDocument";
import * as documentStages from "../../Stages/StagesDocument";
import * as documentStatus from "../../LeadStatus/StatusDocument";
import alimonyTransformations from "../FormTransformations/alimonyTransformations";
import { stageFormDefinition as stageFormDefinitionDocument } from "../FormDefinitions/document";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionAlimony } from "../FormDefinitions/document/alimony";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { ProductData } from "../../../types/ProductService/ProductService";
import { Alimony } from "../../../types/Products/FamilyLaw/Alimony";

export const alimony: ProductData<Alimony> = {
  urlPart: "unterhalt",
  lbUrlPart: "unterhalt",
  label: translate("alimony.label"),
  generalLabel: translate("alimony.label"),
  apiUri: "alimonies",
  persist: persistAlimony,
  stages: stageMetaDataDocument,
  stageConstants: documentStages,
  minimumCaseStatus: documentStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: documentStages.STAGE_INCOMPLETE,
  setBackCaseStage: documentStages.STAGE_READY,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\FamilyLaw\\Alimony\\Alimony",
  formTransformations: alimonyTransformations,
  formDefinition: ({ product }) => stageFormDefinitionDocument(product.productClassName),
  formDefinitionExternals: () => formDefinitionExternals["alimony"],
  fullFormDefinition: ({ product }) => fullFormDefinitionAlimony(product),
  productSpecificDefinition: () => [],
  productCategory: "familyLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.alimony,
};
